import axios from 'axios';
import _ from 'lodash';

export const URL = process.env.URL;
export const BACKEND_URL = process.env.AXIOS_URL;
export const BUCKET_URL = process.env.S3_URL;

export const HTTP = axios.create({
  baseURL: process.env.AXIOS_URL,
  headers: {
    Token: localStorage.getItem('id_token')
  }
});

export const ERROR = function (response) {
  if (response.data.code === 401) {
    if(process.env.NODE_ENV == "development") {
      console.log(response);
    }

    localStorage.removeItem('id_token');
    window.location.href = '/lock';
  }
};

let parsedUserData = null;

const getUserData = function() {
  if (parsedUserData === null) {
    parsedUserData = JSON.parse(localStorage.getItem('user_account'));

    if (parsedUserData.time_zone === null || parsedUserData.time_zone === undefined) {
      parsedUserData['time_zone'] = 'Etc/GMT-0';
    }

    if (parsedUserData.date_format === null || parsedUserData.date_format === undefined) {
      parsedUserData['date_format'] = 'MM/DD/YYYY'
    }
  }

  return parsedUserData;
}

export const clearUserData = function () {
  parsedUserData = null;
}

// todo: get rid of this function, moved to Vuex
export const getUserInfo = function (name) {
  return getUserData()[name];
};

export const updateUserInfo = function (key, value) {
  let data = JSON.parse(localStorage.getItem('user_account'));

  Object.keys(data).forEach(obj => {
    if (obj == key) {
      data[obj] = value;
    }
  });

  localStorage.setItem('user_account', JSON.stringify(data));
  clearUserData();
};

export const excerpt = (str, limit) => {
  var body = new String(str);
  var summary = new String(str);
  summary = summary.substr(0, summary.lastIndexOf(' ', limit)) + '...';

  var returnString = new Object({
    body: body,
    summary: summary
  });

  return returnString;
}



// WEBPACK FOOTER //
// ./src/http-common.js